import { render, staticRenderFns } from "./table-editable-name.vue?vue&type=template&id=4b6cd066"
import script from "./table-editable-name.vue?vue&type=script&lang=js"
export * from "./table-editable-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports